<template>
  <div>
    No preview.
  </div>
</template>

<script>
export default {
  props: {
    value: Object,
    mode: String
  },
  computed: {
    content: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    }
  }
}
</script>
